import React from "react";
import Modal from 'react-modal';
import ScrollAnimation from 'react-animate-on-scroll';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok, FaInfoCircle} from "react-icons/fa";
import { IoMdCloseCircleOutline } from 'react-icons/io';
import 'animate.css';
import DOMPurify from "dompurify";

import SiteDecor from "../../img/site-decor.webp"

const speakerGradients = [
    'bg-[linear-gradient(180deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]',
    'bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]',
    'bg-[linear-gradient(205deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]',
    'bg-[linear-gradient(68deg,_rgba(0,144,100,0)_0%,_rgba(24,170,126,0.75)_66.35%,_#ece66a_100%)]',
    'bg-[linear-gradient(180deg,_rgba(0,144,100,0)_0%,_rgba(24,170,126,0.75)_66.35%,_#ece66a_100%)]',
    'bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]',
];


// СоцСети
const SocialIcons = ({ fbLink, instLink, linkedinLink, tiktokLink, openModal }) => {
    const socialLinks = [
        { link: fbLink, icon: <FaFacebookF className="sm:w-4 sm:h-4 w-2 h-2 text-[#000000]" /> },
        { link: instLink, icon: <FaInstagram className="sm:w-4 sm:h-4 w-2 h-2 text-[#000000]" /> },
        { link: linkedinLink, icon: <FaLinkedinIn className="sm:w-4 sm:h-4 w-2 h-2 text-[#000000]" /> },
        { link: tiktokLink, icon: <FaTiktok className="sm:w-4 sm:h-4 w-2 h-2 text-[#000000]" /> },
    ];

    return (
        <div className="absolute sm:-left-[18px] -left-[10px] -top-[10px] rounded-full z-[20] space-y-2
            bg-[#ddf0d5] p-[3px] box-content text-center"
        >
            {socialLinks.map((social, index) =>
                social.link ? (
                    <a
                        key={index}
                        href={social.link}
                        className="block rounded-full p-2 bg-white hover:bg-gray-300 transition "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {social.icon}
                    </a>
                ) : null
            )}
            <button
                type="button"
                className="block bg-white rounded-full p-2 hover:bg-gray-300 transition"
                onClick={openModal}
            >
                <FaInfoCircle className="sm:w-4 sm:h-4 w-2 h-2 text-black" />
            </button>
        </div>
    );
};

// Модалка Спикера
const SpeakerModal = ({ speaker, isOpen, closeModal }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            ariaHideApp={false}
            className="modal-container fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center z-[70]"
        >
            <div
                className="bg-white rounded-lg w-full max-w-4xl sm:p-6 p-4 shadow-lg shadow-gray-400 sm:m-9 mx-2 my-9 overflow-hidden">
                <div className="flex justify-end mb-2">
                    <button
                        onClick={closeModal}
                        className="text-red-800 hover:text-red-600 focus:outline-none"
                    >
                        <IoMdCloseCircleOutline className="text-red-800 sm:text-4xl text-3xl"/>
                    </button>
                </div>
                <div className="overflow-y-auto h-[80vh] max-h-max">
                    <div className="flex flex-col md:flex-row items-center md:items-start">
                        <div
                            className="mb-4 md:mb-0 md:w-4/12 overflow-hidden rounded-2xl bg-[linear-gradient(270deg,#DEECF5_0%,#CCEFF5_100%)]">
                            <img
                                src={speaker.acf.sm_image}
                                alt={speaker.post_title}
                                className="w-full h-auto rounded-2xl"
                            />
                        </div>
                        <div className="md:w-4/6 md:pl-6 w-full sm:w-auto">
                            <div className="mb-4 pb-4 border-b-2">
                                <h3 className="text-3xl font-semibold text-center md:text-left mb-3">{speaker.post_title}</h3>
                                {speaker.acf.logo && (
                                    <img
                                        src={speaker.acf.logo}
                                        alt="Logo"
                                        className="object-contain w-16 mb-4 m-auto md:ml-0"
                                        style={{"width": speaker.acf.logo_mw + "px"}}
                                    />
                                )}
                                <p className="text-sm text-center md:text-left text-gray-600">{speaker.acf.position}</p>
                            </div>
                            <div className="speacer-popup-info"
                                 dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(speaker.acf.info, {sanitize: true})}}/>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

// Карточка Спикера
const SpeakerCard = ({ speaker, backgroundClass }) => {
    const [modalIsOpen, setIsOpen] = React.useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    return (
        <div
            className="bg-white flex flex-col rounded-t-2xl items-center relative"
            style={{ boxShadow: "rgb(234, 234, 234) 0px 0px 20px 6px, rgb(188 182 182) 0px 0px 6px 2px" }}
        >
            {/* === TOP IMAGE BLOCK === */}
            <div className={`overflow-hidden rounded-t-2xl relative ${backgroundClass}`}>
                <img
                    className="mx-auto w-full h-auto transition duration-[400ms] wp-post-image z-10 relative"
                    src={speaker.acf.sm_image}
                    alt={speaker.post_title}
                />

                <div className="absolute bottom-0 left-0 rounded-full"><img src={SiteDecor} /></div>
            </div>

            <div className="relative sm:px-4 px-2 sm:py-4 py-4 pt-0">
                <div className="relative z-20 sm:-mt-[45px] -mt-[25px] mb-3 sm:w-[94px] sm:h-[94px] w-[64px] h-[64px]
                    flex rounded-full justify-center bg-white p-3 shadow-lg mx-auto
                    after:absolute sm:after:left-[5px] sm:after:top-[5px]
                    after:left-[2px] after:top-[2px]
                    after:border after:border-black
                    sm:after:w-[84px] sm:after:h-[84px]
                    after:w-[60px] after:h-[60px] after:rounded-full"
                >
                    {speaker.acf.logo && (
                        <img
                            src={speaker.acf.logo}
                            alt="Logo"
                            className="object-contain block w-full max-w-[50px]"
                            style={{ width: speaker.acf.logo_mw + "px" }}
                        />
                    )}
                </div>

                <h3 className="sm:text-lg mb-2 font-semibold text-center text-[#151515]">
                    {speaker.post_title}
                </h3>
                <p className="sm:text-sm text-[13px] max-sm:leading-[16px] text-center text-[#505050]">
                    {speaker.acf.position}
                </p>
            </div>

            <button onClick={openModal} className="absolute w-full h-full z-[10]"></button>

            <SpeakerModal speaker={speaker} isOpen={modalIsOpen} closeModal={closeModal} />

            <SocialIcons
                fbLink={speaker.acf.fb_link}
                instLink={speaker.acf.inst_link}
                linkedinLink={speaker.acf.linkedin_link}
                tiktokLink={speaker.acf.tiktok_link}
                openModal={openModal}
            />
        </div>
    );
};


// Основной компонент для отображения спикеров
const EventSpeakersBase = ({speacersData }) => {

    return (
        <>
            {speacersData && speacersData.length > 0 ? (
                <section className="pb-28 relative" id="speacers">
                    <div className="container max-w-screen-xl sm:px-4 w-[90%] sm:w-full mx-auto z-30 relative">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h2 className="font-bold uppercase text-3xl text-center text-[#000] mb-8
                                sm:text-4xl md:mb-[75px] lg:text-[60px]">Спікери 2026</h2>
                        </ScrollAnimation>
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-x-6 gap-x-3 gap-y-6">
                            {speacersData.map((speaker, index) => (
                                <SpeakerCard
                                    key={index}
                                    speaker={speaker}
                                    backgroundClass={speakerGradients[index % speakerGradients.length]} />
                            ))}
                        </div>
                    </div>

                </section>
            ) : null}
        </>
    );
};


export default EventSpeakersBase;
